<style scoped>
    @import url("../../../styles/smartControl/formExtIrrig.scss");
</style>

<template>
    <div class="box_formExtIrrig">

        <div class="mainTit mb-2">
            <span>IRRIGAÇÃO EXTERNA</span>
        </div>

        <div class="menuForm">

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Origem da irrigação:</span>
                <span class="ml-2 elInput" :style="{'justify-content': 'flex-end'}">Externa</span>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Data da irrigação:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Hora da irrigação:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="deviceSelected"
                    :items="liDevicesExib"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarDevice(deviceSelected)"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Título Atuador/setor:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="atuadorSelected"
                    :items="liSelectAtuador"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarAtuador(atuadorSelected)"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Minutos de irrigação:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.minutos"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="15:01"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Nota:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.nota"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="Ex.: Coloquei 5 litros de água diretamente na planta"
                        @change="atualizarFormulario()"
                    />
                </div>
            </div>

        </div>

        <v-btn @click="addExtIrrig()" v-if="!flagMsgErro"
        class="mt-2 mb-2"
        block 
        :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
        >adicionar</v-btn>

        <div v-if="flagMsgErro" class="mt-1 mb-2" :style="{'align-self':'center','color':'white','font-size':'0.8rem','font-weight':'100'}">{{ msgErro }}</div>
    </div>
</template>

<script>
import { convHhmmToUtc } from "../auxSC/handleTimeConv.js"; // criado em 04/05/2026

export default {

    props:['agent_unit','cl','sys_agend','flagStrWrap'],

    data() {
        return {

            // -- default form
            formLocal: {
                'dt_str':'01/01/2001',
                'hhmm':'05:01',
                'controlador':'',
                'atuador':'',
                'device_id':'',
                'minutos':1,
                'nota':'',
            },

            // -- handle atuadores.
            liDevices: [],
            liDevicesExib: [],
            deviceSelected: '',
            atuadorSelected: '',
            liSelectAtuador: [],

            /*{
            'received_at':dt_end, # utc
            'data':dt_str, # utc
            'info':'irrig',
            'tit':'Elemento Irrigação', # exib
            'cl':db_name,
            'sistema_agend':sistema_agend,
            'device_id':device_id, # ttn
            'irrig_decisor':irrig_decisor, # origem do input hídrico
            'minutos':minutos, # act
            'segundos':segundos, # act
            'nota':f'{minutos} minutos de irrigação foram realizados a partir de {irrig_decisor}, no sistema {sistema_agend} e dispositivo {device_id} às {dt_str} utc.',
            }*/

            flagMsgErro:false,
            msgErro:'Preencha corretamente todos os campos.',
        }
    },

    methods:{

        addExtIrrig() { 

            // -- validar form.

            //console.log('formLocal: ',this.formLocal)

            const device_ctrl = this.formLocal['controlador']
            const device_atuador = this.formLocal['atuador']
            const device_id = this.formLocal['device_id']
            if (device_ctrl == '' || device_atuador == '' || device_id == '') {
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }
            else { this.flagMsgErro = false }

            // -- validação de quantidade.
            const minutos = parseFloat(this.formLocal['minutos'])
            if (minutos <= 0) { 
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }
            else { this.flagMsgErro = false }

            // -- converter minutos para segundos.
            let segundos = Number((minutos * 60).toFixed(2));

            // -- validação do formato da data do input.
            const flag_hhmm_e_dtStr_ok = this.atualizarFormulario()
            if (flag_hhmm_e_dtStr_ok == false) { 
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                return 
            }
            else { this.flagMsgErro = false }

            // -- converter horário local para utc nos dois formatos.
            const hhmmLocal = this.formLocal['hhmm']
            const dataStr = this.formLocal['dt_str']
            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
            //const dataStr = new Date().toLocaleDateString("pt-PT"); // data string no formato pt dd/mm/aaaa
            //console.log('[addExtIrrig] dataStr: ',dataStr)
            const hhmmUTC = convHhmmToUtc(hhmmLocal, tzName, dataStr) // hh:mm e dd/mm/aaaa

            const dt_str = `${dataStr}-${hhmmUTC}` // problema com dt na virada do dia ??
            const dt_end = this.convStrToDt(dt_str) // string --> dt

            // -- nota final (se estiver vazia).
            if (this.formLocal['nota'] == '') { this.formLocal['nota'] == 'Irrigação externa feita pelo Cliente' }

            let endForm = {
                'received_at':dt_end, // utc
                'data':dt_str, // utc
                'info':'irrig',
                'tit':'Elemento Irrigação',
                'cl':this.cl,
                'sistema_agend':this.sys_agend,
                'device_id':device_id, // irrig externoa associada ao device_id do atuador do setor
                'setor_atuador':device_atuador,
                'irrig_decisor':'Cliente',
                'minutos':minutos,
                'segundos':segundos,
                'nota':this.formLocal['nota'] // opcional
            }
            //console.log('endForm: ',endForm)

            // -- emitir input endForm.
            this.$emit('fromChild2input', endForm) // dict input_last_info
        },

        atualizarFormulario() {

            //console.log('formLocal: ',this.formLocal)

            // -- verificação se o momento da irrigação está no formato correto.
            const flag_fmt_hhmm_ok = this.validarHoraHhmm(this.formLocal['hhmm'])
            const flag_fmt_dtStr_ok = this.validarDataDdMmAaaa(this.formLocal['dt_str'])
            if (flag_fmt_hhmm_ok && flag_fmt_dtStr_ok) { 
                this.flagMsgErro = false // reset msg erro (se houver)
                return true
            }
            else { 
                this.flagMsgErro = true // habilitar msg erro
                this.msgErro = 'Formatos 01/01/2001 e 00:02 obrigatório.'
                this.formLocal['hhmm'] = '05:02' // reset para o fmt correto
                this.formLocal['dt_str'] = '01/01/2001' // reset para o fmt correto
                return false
            }
        },

        validarHoraHhmm(valor) {
            const regex = /^(\d{2}):(\d{2})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const hora = parseInt(match[1], 10);
            const minuto = parseInt(match[2], 10);

            return (
                hora >= 0 &&
                hora <= 23 &&
                minuto >= 0 &&
                minuto <= 59
            );
        },

        validarDataDdMmAaaa(valor) {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const dia = parseInt(match[1], 10);
            const mes = parseInt(match[2], 10);
            const ano = parseInt(match[3], 10);

            if (mes < 1 || mes > 12) return false;

            const dt = new Date(ano, mes - 1, dia);

            return (
                dt.getFullYear() === ano &&
                dt.getMonth() === mes - 1 &&
                dt.getDate() === dia
            );
        },

        convStrToDt(dateHrUtc) {
            const [data, hora] = dateHrUtc.split("-");
            const [dia, mes, ano] = data.split("/").map(Number);
            const [hh, mm] = hora.split(":").map(Number);

            return new Date(Date.UTC(ano, mes - 1, dia, hh, mm));
        },

        trocarDevice(deviceSelected) {

            let c=0
            while (c < this.liDevices.length) {
                //console.log('deviceSelected: ',deviceSelected) 
                //console.log('this.liDevices[c][nome_device]: ',this.liDevices[c]['nome_device']) 
                if (this.liDevices[c]['nome_device'] == deviceSelected) {

                    this.formLocal['device_id'] = this.liDevices[c]['device']
                    this.formLocal['controlador'] = deviceSelected
                    
                    let liGeralDispositivo = this.liDevices[c]['liAtuadores'] // init this.liGeralDispositivo
                    let j=0
                    while (j < liGeralDispositivo.length) {
                        this.liSelectAtuador.push(liGeralDispositivo[j]['tit']) // recortar tit
                        j++
                    }
                    //console.log('this.liSelectAtuador: ',this.liSelectAtuador)
                    c=this.liDevices.length // break
                }
                c++
            }
        },

        trocarAtuador(atuadorSelected) {
            //console.log('atuadorSelected: ',atuadorSelected)
            this.formLocal['atuador'] = atuadorSelected
        },

        init() {
            this.liDevices = []
            this.liDevicesExib = []

            let liAtuadores = this.agent_unit['atuadores'] // lista de controladores contendo atuadores (pinos)
            let c=0
            while ( c < liAtuadores.length ) {

                // hierarquia do documento:
                // lista dispositivos -> lista atuadores -> 

                // A ROTINA ABAIXO PODE SER REMOVIDA, SE liAtu e liDevices for passado via props (!) 08/01/2026

                let params = liAtuadores[c]['params']
                let liAtu = [] // reset
                let j=0
                while (j < params.length) {

                    if (params[j]['sub_marcador'] == 'irrig') { 

                        liAtu.push({
                            'tit':params[j]['titulo'],
                            'atuante':params[j]['sub_marcador']
                        })
                    }
                    j++
                }
                this.liDevices.push({
                    'nome_device':liAtuadores[c]['nome'], 
                    'device':liAtuadores[c]['device'], 
                    'liAtuadores':liAtu
                })
                this.liDevicesExib.push(liAtuadores[c]['nome'])
                c++
            }
        },
    },

    created() {
        //window.scrollTo(0,0)
        this.init()
    }
}
</script>
